import { render } from "./CategoryEditor.vue?vue&type=template&id=c691cabe&scoped=true"
import script from "./CategoryEditor.vue?vue&type=script&lang=js"
export * from "./CategoryEditor.vue?vue&type=script&lang=js"

import "./CategoryEditor.vue?vue&type=style&index=0&id=c691cabe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c691cabe"]])

export default __exports__